<template>
    <div class="block-style1">
		<sub-title :title="title||''"></sub-title>
		<div class="block">
			<div class="image-list">
				<div class="item" v-for="(item,i) in list.slice(0,6)" :key="i">
					<!-- <router-link :to="`/exhibit-detail-${item.id}`" target="_blank"> -->
						<el-image fit="cover" class="image" :src="$img(item.thumb)" @error="item.thumb = defaultGoodsImage" />
						<p>{{item.title}}</p>
					<!-- </router-link> -->
				</div>
			</div>
			<div class="info-list">
				<list3 :list="list.slice(0,10)"></list3>
			</div>
		</div>
		
    </div>
</template>
 
<script>
    import { mapGetters } from "vuex"
	import {
		exhibitList,
		// newsCat
	} from "@/api/cms/exhibit";
	import SubTitle from "@/components/SubTitle"
	import DescText from "@/components/DescText"
	import list3 from "./list3"
	
    export default {
        name: "list2",
        components: {
			SubTitle,
			DescText,
			list3
        },
        props: {
            config: {
                type: Object,
                // required: true
            },
			title: {
                type: String,
                // required: true
            },
			catId: {
                type: Number,
                required: true
            },
        },
        data() {
            return {
				list:[]
            }
        },
        created() {
			this.getList()
        },
        computed: {
            ...mapGetters(["defaultGoodsImage"])
        },
        methods: {
            getList(){
				exhibitList({
					cat_id:this.catId,
					page_size:20,
				}).then(res=>{
					if (res.code == 0 && res.data) {
						this.list = res.data.list;
					}
					// this.loading = false;
				}).catch(err => {
					// this.loading = false;
					this.$message.error(err.message);
				});
			}
        },
        watch: {
            config: {
                handler: (e)=>{
                },
                immediate: true,
                deep: true
            }
        }
    }
</script>

<style lang="scss" scoped>
.block-style1{
	margin-bottom: 15px;
}
.block{
	display: flex;
	flex-wrap: wrap;
	
	.image-list{
		width: 50%;
		display: flex;
		flex-wrap: wrap;
		.item:nth-child(3n+1){
			margin-left:0;
		}
		.item{
			width: 32%;
			margin-left: 2%;
			overflow: hidden;
			position: relative;
			margin-bottom: 20px;
			padding: 0;
			height: 140px;
			.image{
				// width: 100%;
				height: 140px;
			}
			p{
				position: absolute;
				z-index: 9;
				// top: 0;
				left: 0;
				bottom: 0;
				background-color: rgb(0, 0, 0,0.6);
				color: #fff;
				font-size: 14px;
				text-align: center;
				overflow: hidden;
				text-overflow:ellipsis;
				white-space: nowrap;
				// padding:  10px 0 ;
				line-height: 30px;
				width: 100%;
			}
		}
	}
	.info-list{
		width: 50%;
		padding: 0  0 0 15px;
		overflow: hidden;
		box-sizing: border-box;
	}
}


</style>
